import { Button, breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { LoadingDots } from '@eti/components';
import { useTranslation } from '@eti/providers';

const buttonStyles = css`
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    width: auto;
  }
`;
interface PayButtonProps {
  isLoading: boolean;
}

const PayButton = ({ isLoading }: PayButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      className={buttonStyles}
      data-testid="postbookingProducts-payButton-Button"
      type="submit"
      variant="primary"
    >
      {isLoading ? (
        <LoadingDots dataTestId="postbookingProducts-loadingDots" />
      ) : (
        t('Postbooking.ProductPage.SubmitButton')
      )}
    </Button>
  );
};

export default PayButton;
